
export enum ActivityStatusType {
  PLANNED = '5949326f-8278-4ed9-90b5-ae6dfbde0c05',
  COMPLETED = '15b3306e-7180-44f2-9096-9ca4f85d8d67',
  CANCELLED = 'de446558-0baf-4060-8186-a880bc2f4476'
}
